<template>
  <section>
    <v-card >
      <v-card-text>
        <v-alert dark dense prominent color="primary" icon="mdi-school" class="mb-0">
          The scenario is intended for the staff
        </v-alert>
      </v-card-text>
      <v-divider/>
      <v-card-text v-if="scenario">
        <vue-editor id="staff-scenario"
                    v-model="scenario.body"
                    :editor-toolbar="toolbar"
        />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn color="success" @click="updateScenario">Save</v-btn>
      </v-card-actions>
    </v-card>
  </section>
</template>

<script>
export default {
  props: {
    mock: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    scenario: null,
    api_errors: [],

    toolbar: [
      [{ header: [false, 1, 2, 3, 4, 5, 6] }, "bold", "italic", "underline"],
      [{align:""}, {align:"center"}, {align:"right"}, {align:"justify"}],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: []}],
      ["image", "link", "formula"],
    ],
  }),
  created() {
    this.loadScenario()
  },
  methods: {
    async loadScenario() {
      this.scenario = await this.axios.get(`api/mocks/${this.$route.params.mock_id}/scenario`)
          .then(({data}) => data.data)
    },
    updateScenario() {
      this.api_errors = []
      this.app_loading = true
      this.axios.put(`api/mocks/${this.$route.params.mock_id}/scenario`, this.scenario)
        .then(({data}) => { this.scenario = data.data })
        .catch(errors => {this.api_errors = errors.response.data.errors })
        .then(() => {this.app_loading = false})
    }
  }
}
</script>